import { Extension } from '@tiptap/core';
import { Blockquote } from '@tiptap/extension-blockquote';
import { Bold } from '@tiptap/extension-bold';
import { BulletList } from '@tiptap/extension-bullet-list';
import { Code } from '@tiptap/extension-code';
import { CodeBlock } from '@tiptap/extension-code-block';
import { Document } from '@tiptap/extension-document';
import { Dropcursor } from '@tiptap/extension-dropcursor';
import { Gapcursor } from '@tiptap/extension-gapcursor';
import { HardBreak } from '@tiptap/extension-hard-break';
import { Heading } from '@tiptap/extension-heading';
import { History } from '@tiptap/extension-history';
import { HorizontalRule } from '@tiptap/extension-horizontal-rule';
import { Italic } from '@tiptap/extension-italic';
import { ListItem } from '@tiptap/extension-list-item';
import { OrderedList } from '@tiptap/extension-ordered-list';
import { Paragraph } from '@tiptap/extension-paragraph';
import { Strike } from '@tiptap/extension-strike';
import { Text } from '@tiptap/extension-text';

const StarterKit = Extension.create({
    name: `starterKit`,
    // eslint-disable-next-line max-statements
    addExtensions() {
        const extensions = [];
        // note: in runtime it possibly be undefined
        const options = this.options;
        if ((options === null || options === void 0 ? void 0 : options.blockquote) !== false) {
            extensions.push(Blockquote.configure(options === null || options === void 0 ? void 0 : options.blockquote));
        }
        if ((options === null || options === void 0 ? void 0 : options.bold) !== false) {
            extensions.push(Bold.configure(options === null || options === void 0 ? void 0 : options.bold));
        }
        if ((options === null || options === void 0 ? void 0 : options.bulletList) !== false) {
            extensions.push(BulletList.configure(options === null || options === void 0 ? void 0 : options.bulletList));
        }
        if ((options === null || options === void 0 ? void 0 : options.code) !== false) {
            extensions.push(Code.configure(options === null || options === void 0 ? void 0 : options.code));
        }
        if ((options === null || options === void 0 ? void 0 : options.codeBlock) !== false) {
            extensions.push(CodeBlock.configure(options === null || options === void 0 ? void 0 : options.codeBlock));
        }
        if ((options === null || options === void 0 ? void 0 : options.document) !== false) {
            extensions.push(Document.configure(options === null || options === void 0 ? void 0 : options.document));
        }
        if ((options === null || options === void 0 ? void 0 : options.dropcursor) !== false) {
            extensions.push(Dropcursor.configure(options === null || options === void 0 ? void 0 : options.dropcursor));
        }
        if ((options === null || options === void 0 ? void 0 : options.gapcursor) !== false) {
            extensions.push(Gapcursor.configure(options === null || options === void 0 ? void 0 : options.gapcursor));
        }
        if ((options === null || options === void 0 ? void 0 : options.hardBreak) !== false) {
            extensions.push(HardBreak.configure(options === null || options === void 0 ? void 0 : options.hardBreak));
        }
        if ((options === null || options === void 0 ? void 0 : options.heading) !== false) {
            extensions.push(Heading.configure(options === null || options === void 0 ? void 0 : options.heading));
        }
        if ((options === null || options === void 0 ? void 0 : options.history) !== false) {
            extensions.push(History.configure(Object.assign({ depth: 10, newGroupDelay: 100 }, options === null || options === void 0 ? void 0 : options.history)));
        }
        if ((options === null || options === void 0 ? void 0 : options.horizontalRule) !== false) {
            extensions.push(HorizontalRule.configure(options === null || options === void 0 ? void 0 : options.horizontalRule));
        }
        if ((options === null || options === void 0 ? void 0 : options.italic) !== false) {
            extensions.push(Italic.configure(options === null || options === void 0 ? void 0 : options.italic));
        }
        if ((options === null || options === void 0 ? void 0 : options.listItem) !== false) {
            extensions.push(ListItem.configure(options === null || options === void 0 ? void 0 : options.listItem));
        }
        if ((options === null || options === void 0 ? void 0 : options.orderedList) !== false) {
            extensions.push(OrderedList.configure(options === null || options === void 0 ? void 0 : options.orderedList));
        }
        if ((options === null || options === void 0 ? void 0 : options.paragraph) !== false) {
            extensions.push(Paragraph.configure(options === null || options === void 0 ? void 0 : options.paragraph));
        }
        if ((options === null || options === void 0 ? void 0 : options.strike) !== false) {
            extensions.push(Strike.configure(options === null || options === void 0 ? void 0 : options.strike));
        }
        if ((options === null || options === void 0 ? void 0 : options.text) !== false) {
            extensions.push(Text.configure(options === null || options === void 0 ? void 0 : options.text));
        }
        return extensions;
    },
});

/**
 * Generated bundle index. Do not edit.
 */

export { StarterKit };
